import { Action } from '@ngrx/store';
import { INotification } from '@interfaces/INotification';

export enum ENotificationsActions {
  SetNotifications = '[Notifications] Set Notifications',
  SubscribeToNotifications = '[Notifications] Subscribe To Notifications',
  ReadNotifications = '[Notifications] Read Notifications',
  DeleteNotificationFromState = '[Notifications] Delete Notification From State',
  DeleteAllNotification = '[Notifications] Delete All Notification',
  AddNotification = '[Notifications] Add Notification',
}

export class AddNotification implements Action {
  public readonly type = ENotificationsActions.AddNotification;

  constructor(public notification: INotification) {}
}

export class ReadNotifications implements Action {
  public readonly type = ENotificationsActions.ReadNotifications;
}

export class DeleteNotificationFromState implements Action {
  public readonly type = ENotificationsActions.DeleteNotificationFromState;

  constructor(public id: number) {}
}
export class DeleteAllNotification implements Action {
  readonly type = ENotificationsActions.DeleteAllNotification;
}

export class SetNotifications implements Action {
  public readonly type = ENotificationsActions.SetNotifications;

  constructor(public notifications: INotification[]) {}
}

export class SubscribeToNotifications implements Action {
  public readonly type = ENotificationsActions.SubscribeToNotifications;

  constructor(public userId: number) {}
}

export type NotificationsActions =
  | SetNotifications
  | DeleteNotificationFromState
  | AddNotification
  | DeleteAllNotification
  | ReadNotifications;
